import React from "react";
import { useI18n } from "@/contexts/I18nContext";
import { useNavigate } from "react-router-dom";

const AdminLogin = () => {
  const { t } = useI18n();
  const navigate = useNavigate();

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const handleLogin = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#0A1128] flex items-center justify-center p-6 relative overflow-hidden">
      <div className="absolute inset-0 grain-overlay opacity-20" />
      <div className="absolute inset-0" style={{
        backgroundImage: "radial-gradient(circle at 20% 30%, rgba(212,175,55,0.08), transparent 50%), radial-gradient(circle at 80% 70%, rgba(212,175,55,0.05), transparent 50%)",
      }} />
      <div className="relative bg-[#161E32] border border-white/10 rounded-sm p-10 max-w-md w-full" data-testid="admin-login-card">
        <div className="text-center mb-10">
          <div className="w-14 h-14 border border-[#D4AF37] mx-auto flex items-center justify-center rounded-sm mb-5">
            <span className="font-display text-[#D4AF37] text-2xl">N</span>
          </div>
          <h1 className="font-display text-2xl text-white mb-2">{t("admin.login")}</h1>
          <p className="text-xs text-white/50 uppercase tracking-[0.2em]">{t("admin.loginNote")}</p>
        </div>
        <button onClick={handleLogin} data-testid="admin-google-login" className="w-full bg-white text-[#0A1128] font-semibold px-6 py-3.5 rounded-sm flex items-center justify-center gap-3 hover:bg-[#F3E5AB] transition-colors">
          <svg width="18" height="18" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A10.99 10.99 0 0 0 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.37-.35-2.09s.13-1.43.35-2.09V7.07H2.18a10.99 10.99 0 0 0 0 9.86l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/></svg>
          {t("admin.loginGoogle")}
        </button>
        <p className="text-center text-xs text-white/40 mt-7">Authorized admin: ferhat241@gmail.com</p>
      </div>
    </div>
  );
};

export default AdminLogin;
